import React from "react";
import { TicTacToe } from "./TicTacToe";
import { registerGame } from "../common/registry";
import { Game } from "../common/types";

// XOX oyunu için icon
const TicTacToeIcon: React.ReactNode = (
  <div className="w-full h-full flex items-center justify-center relative">
    <div className="text-blue-500 font-bold text-4xl absolute top-0 left-1">
      X
    </div>
    <div className="text-red-500 font-bold text-4xl absolute bottom-0 right-0">
      O
    </div>
    <div className="text-blue-500 font-bold text-4xl absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      X
    </div>
  </div>
);

// XOX oyununu kaydet
const ticTacToeGame: Game = {
  id: "tic-tac-toe",
  name: "games.list.ticTacToe.title",
  description: "games.list.ticTacToe.description",
  component: TicTacToe,
  icon: TicTacToeIcon,
  category: "strategy",
};

// Oyunu otomatik kaydet
registerGame(ticTacToeGame);

export { TicTacToe };
export default ticTacToeGame;
